/* ********************************
 *         Data Handlers
 * ********************************
 */

/* eslint-disable no-unused-vars */
import { state } from "./index";
import store from "@/store";
import router from "@/router";
import { loadData } from "./data-loader";


/** 
  *  Submit Form Data
  *  
  *   @param  {Object} payload Contain requires inputs for adding data
  *     @property {Object, required} courseOutlineRegistrationInput : {
          academicPeriodId: "", // {String} Get it from filter selection.
          periodCode: "",       // {String} Get it from filter selection.
          degreeId: "",         // {String} Get it from filter selection.
          subjectGroupId: "",   // {String} Get it from filter selection.
          subjectId: "",        // {String} Get it from Course Outline Selection.
          subjectCode: "",      // {String} "----------------------------------"
          subjectName: "",      // {String} "----------------------------------"
          courseOutlineId: "",  // {String} "----------------------------------"
          teacherId: "",        // {String} "----------------------------------"
          teacherCode: "",      // {String} "----------------------------------"
        }
  * 
  */

export const submitForm = async (payload) => {
  const result = await store.dispatch("Courses/CourseOutlineRegistration/addCourseOutlineRegistration", payload);
  return result;
}


/** 
  *  Import All Exam Question
  *  
  *   @param  {Object} payload Contain requires inputs for adding data
  *     @property {Object, required} courseOutlineRegistrationInput : {
          academicPeriodId: "", // {String} Get it from filter selection.
          periodCode: "",       // {String} Get it from filter selection.
          degreeId: "",         // {String} Get it from filter selection.
          subjectGroupId: "",   // {String} Get it from filter selection.
          subjectId: "",        // {String} Get it from Course Outline Selection.
          subjectCode: "",      // {String} "----------------------------------"
          subjectName: "",      // {String} "----------------------------------"
          courseOutlineId: "",  // {String} "----------------------------------"
          teacherId: "",        // {String} "----------------------------------"
          teacherCode: "",      // {String} "----------------------------------"
        }
  * 
  */

export const importAllExamQuestion = async () => {
  const workbook = transformData(state.local.table.data, state.local.form.input);
  const result = await store.dispatch("Examination/bulkAddExamQuestion", { workbook });
  return result;
}

/** 
  *  Import Selected Exam Question Sheet
  *  
  *   @param  {Object} payload Contain requires inputs for adding data
  *     @property {Object, required} courseOutlineRegistrationInput : {
          academicPeriodId: "", // {String} Get it from filter selection.
          periodCode: "",       // {String} Get it from filter selection.
          degreeId: "",         // {String} Get it from filter selection.
          subjectGroupId: "",   // {String} Get it from filter selection.
          subjectId: "",        // {String} Get it from Course Outline Selection.
          subjectCode: "",      // {String} "----------------------------------"
          subjectName: "",      // {String} "----------------------------------"
          courseOutlineId: "",  // {String} "----------------------------------"
          teacherId: "",        // {String} "----------------------------------"
          teacherCode: "",      // {String} "----------------------------------"
        }
  * 
  */

 export const importSelectedExamQuestion = async () => {
  const workbook = transformData(state.local.table.data, state.local.form.input);
  const result = await store.dispatch("Examination/bulkAddExamQuestion", { workbook });
  return result;
}

function transformData(iteration, input) {
  return iteration.map((sheet, index) => {
    return sheet.map(question => {
      return {
        examId: input.examId,
        subjectId: input.subjectId,
        teacherId: input.teacherId,
        examQuestionInput: {
          subjectCode: input.subjectCode,
          teacherCode: input.teacherCode,
          unitSeq: index + 1,
          questionTypeCode: question.CHOICE3.length < 1 ? "TF" : "MP",
          nameLocal: question.QUESTION,
          nameEng: question.QUESTION,
          picturePath: "",
          score: input.score,
          isRandomChoice: question.RANDOM === "1",
          isActive: true,
        },
        examAnswersInput: [
          {
            no: "1",
            nameLocal: question.CHOICE1,
            nameEng: question.CHOICE1,
            isCorrected: question.ANSWER === "1" ? true : false
          },
          {
            no: "2",
            nameLocal: question.CHOICE2,
            nameEng: question.CHOICE2,
            isCorrected: question.ANSWER === "2" ? true : false
          },
          {
            no: "3",
            nameLocal: question.CHOICE3,
            nameEng: question.CHOICE3,
            isCorrected: question.ANSWER === "3" ? true : false
          },
          {
            no: "4",
            nameLocal: question.CHOICE4,
            nameEng: question.CHOICE4,
            isCorrected: question.ANSWER === "4" ? true : false
          },
        ]
      }
    })
  });
}

// export const addData = async (payload) => {
//   const sample = {
//     courseOutlineRegistrationInput: {
//       academicPeriodId: "",
//       periodCode: "",
//       courseOutlineId: "",
//       degreeId: "",
//       subjectGroupId: "",
//       subjectId: "",
//       subjectCode: "",
//       subjectName: "",
//       teacherId: "",
//       teacherCode: "",
//     }
//   };
//   store.dispatch("Courses/CourseOutlineRegistration/addCourseOutlineRegistration", sample);
// };



// export const handleSelectedListItem = (tr) => {
//   const id = tr.id || null;
//   if (id) {
//     router.push(
//       {
//         name: "vdo-set-topic",
//         params: {
//           vdoSetUnitId: id
//         }
//       }
//     )
//   }
// }


export const handleEdit = (data) => {
  if (data) {
    // state.local.form.id = data.id;
    // state.local.form.teacherId = data.teacher.id;
    // state.local.form.vdoSetUnitInput.unitSeq = data.unitSeq;
    // state.local.form.vdoSetUnitInput.code = state.local.vdoSet.code;
    // state.local.form.vdoSetUnitInput.totalVdoLength = data.vdoSet.totalVdoLength;
    // state.local.form.vdoSetUnitInput.status = ""
    // state.local.form.vdoSetUnitInput.remark = ""
    state.local.editor = { name: "EditExamQuestion", mode: "edit", active: true };
  }
}


export const handleDeleteListItem = async (tr) => {
  const sure = confirm("Yes or No");
  // const sure = confirm(`ยืนยันการลบ Vdo Set Unit\nวิชา ${tr.subject.nameLocal} (${tr.code})\nสอนโดย ${tr.teacher.firstNameLocal} ${tr.teacher.lastNameLocal} ใช่หรือไม่?`);
  const { id } = tr;
  if (sure) {
    await store.dispatch("Courses/CourseOutlineRegistration/deleteCourseOutlineRegistration", { id });
    alert('Delete Success');
    loadData();
  }
}


// export const submitForm = (formInput) => {
//   if (formInput) {
//     if (state.local.editor.mode === "edit") {
//       _store.dispatch('VdoSet/Units/updateVdoSetUnit', formInput);
//     } else {
//       _store.dispatch('VdoSet/Units/addVdoSetUnit', formInput);
//     }
//   } else {
//     alert("Requires to fill up the form");
//   }
// }
